import React from 'react';
import { NotiBoardContainer, NotiBoardSimple, NotiTitle, NotiDate } from './NoticeBoard.styles';

interface NoticeBoardProps {
  onClick: () => void;
  id: number;
  title: string;
  date: string;
}

const NotiBoard: React.FC<NoticeBoardProps> = ({ onClick, id, title, date }) => {
  return (
    <NotiBoardContainer onClick={onClick}>
      <NotiBoardSimple>
        <NotiTitle>{title}</NotiTitle>
        <NotiDate>{date}</NotiDate>
      </NotiBoardSimple>
    </NotiBoardContainer>
  );
};

export default NotiBoard;
